export enum MenuItemType {
    INTERNAL = "Internal",
    SUBMENU = "Submenu",
    EXTERNAL = "External",
    TAG = "Tag",
}

export interface MenuItem {
    active?: boolean;
    children?: MenuItem[];
    label: string;
    url?: string;
    type: MenuItemType;
}

export interface MenuData {
    menuItems: MenuItem[];
    HomeLink: string;
}

export enum SiteTheme {
    GARANT = "Garant",
    ELDORADO = "Eldorado",
    MINSTINGEN = "Minstingen",
}

export interface FilterData {
    categories: FilterCategory[];
    totalCount: number;
}

export interface FilterItem {
    name: string;
    title: string;
    disabled: boolean;
    selected: boolean;
    count: number;
}

export interface FilterCategory {
    name: string;
    title: string;
    items: FilterItem[];
}